import http from "./http";


// 云服务器购买ip下单
function placeOrder(params={}) {
  return http.post("/order", params)
}


// 获取用户信息
function getUserInfo() {
  return http.get("/general/user/info")
}


//支付
function Payment(params={}) {
  return http.post("/pay/apiPay", params)
}


// 检查订单支付状态
function checkOrderStatus(orderSn) {
  return http.post("/pay/checkOrderStatus", {
    "sn": orderSn,
  });
}




export default {
  placeOrder,
  getUserInfo,
  Payment,
  checkOrderStatus
}



// WEBPACK FOOTER //
// ./src/utils/api.js